import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { FormControl } from '@angular/forms';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { TabConst } from 'src/app/tabms/tab-consts';

@Component({
  selector: 'app-base-dropdown',
  templateUrl: './base-dropdown.component.html',
  styleUrl: './base-dropdown.component.scss'
})
export class BaseDropdownComponent {
  @Input() set service(_service) {
    if (!_service) return;
    this.serviceInstance = _service;
  }
  @Output() selectedItem = new EventEmitter<any>();
  @Input() selectValue: string;
  @Input() pageSize = 15;
  @Input() customStyle: string;
  @Input() customClass
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE // New input for size control

  // @Input() set selectedId(id: string | null) {
  //   console.log('id', id);
  //   if (id) { this.getById(id); }
  // }

  @Input() selectedId: string | null;

  // @Input() set options(options: string[] | [null]) {
  //   if (options)  this.getOptions = true
  // }
  getOptions: boolean = false;
  searchControl = new FormControl();

  filteredOptions: string[] = [];
  currentLang: string;
  serviceInstance;

  @ViewChild(MatAutocompleteTrigger) autoTrigger: MatAutocompleteTrigger | undefined;

  currentPage: number = 0;
  // pageSize: number = 15;
  searchText: string = null;
  value: string;
  private destroy$ = new Subject<void>();

  get allClasses() {
    return {
      'custom-combo': true,
      'rtl': this.currentLang === 'ar',
      'ltr': this.currentLang !== 'ar',
      'mat-form-field-compact': this.size === 'compact',
      'mat-form-field-xs': this.size === 'xs',
      ...this.customClass  //object
    };
  }

  constructor(
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService,
    private cdr: ChangeDetectorRef
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();
    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe((dir) => {
      dir === RTL ? (this.currentLang = 'ar') : (this.currentLang = 'en');
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedId']) {
      console.log('selectedId changed:', this.selectedId);

      if (!this.selectedId) {
        // console.log('Clearing dropdown values');
        this.selectedId = null
        setTimeout(() => {
          this.searchControl.setValue(null);
          this.cdr.detectChanges();
        }, 0);
      } else {
        if (typeof this.selectedId !== 'string') return;
        this.getById(this.selectedId);
      }
    }

    if (changes['selectValue']) this.selectValue = changes['selectValue'].currentValue.toLowerCase();
  }

  ngOnInit(): void {
    this.searchControl.valueChanges.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe({
      next: (value) => {
        // debugger
        // console.log('value', value);
        this.searchText = value;
        this.getAllData(true);
      }
    });

    // setTimeout(() => {
    //   this.searchControl.setValue(null, { emitEvent: true });
    // }, 0);
  }

  getAllData(search = false) {
    let params = this.searchText ? { [this.selectValue]: this.searchText } : null;
    let pageNumber = search ? (this.currentPage = 0) : ++this.currentPage;
    let pageSize = this.pageSize;
    // debugger
    this.serviceInstance
      .GetalldatabyfilterWithCount(pageNumber, pageSize, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          // debugger
          const data = res.result.items.map((item) => item._entitydto);
          this.filteredOptions = search ? data : [...this.filteredOptions, ...data];
          // console.log('dropdown-list', this.filteredOptions);
          // debugger
        }
      });
  }

  onAutocompleteOpened(trigger: MatAutocompleteTrigger): void {
    // debugger

    setTimeout(() => {
      const panel = trigger.autocomplete.panel?.nativeElement;

      if (panel) {
        panel.addEventListener('scroll', this.onScroll.bind(this));
      }
    }, 100);
  }

  onScroll(): void {
    const panel = this.autoTrigger?.autocomplete?.panel?.nativeElement;

    if (panel) {
      const { scrollTop, scrollHeight, clientHeight } = panel;
      if (scrollTop + clientHeight >= scrollHeight) {
        this.getAllData();
      }
    }
  }

  onSearch(value: string) {
    this.searchControl.setValue(value);
  }

  onSelect(item: any) {
    //
    // this.value = this.selectValue ? item[this.selectValue] : '';
    this.searchControl.setValue(item[this.selectValue]);
    this.selectedItem.emit(item);
  }

  getById(id: string) {
    // console.log('id', id);
    this.serviceInstance
      .get(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (!res.result) this.getAllData(true);
          else {
            const item = res.result;
            this.searchControl.setValue(item[this.selectValue]);
            this.filteredOptions = [item[this.selectValue]];
          }

        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
